import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router, { initializeAuth } from './router'

const app = createApp(App)

app.use(router)

// Initialize auth before mounting the app
initializeAuth()

app.mount('#app')
